var singleSidebarJS = (function () {

  var tocSect, sidebarLinks, sidebarLinksParent, content, sideDivWrapper, sideBarInner, secOfCallOut, secOfAlsoRead;

  function init() {
    sidebarLinksParent = document.querySelectorAll('.single-tmp__toc-list ul li');
    content = document.querySelector('.single-tmp__main');
    sidebarLinks = document.querySelectorAll('.single-tmp__toc-list ul li a');
    tocSect = document.querySelector('.single-tmp__sidebar .single-tmp__toc-container');
    sideBarInner = document.querySelector('.single-tmp__sidebar .single-tmp__sidebar-inner-sticky');
    sideDivWrapper = document.querySelector('.guide-template__articles-box');
    secOfCallOut = document.getElementById('single-sidebar-callout');
    secOfAlsoRead = document.getElementById('single-sidebar-also-read');

    uiBindings();
  }

  function uiBindings() {
    function handleScrollAndResizeEvents() {
      sideBarInnerSecHandle();
    }

    window.addEventListener('scroll', handleScrollAndResizeEvents);
    window.addEventListener('resize', handleScrollAndResizeEvents);

  }

  function sideBarInnerSecHandle() {
    if (window.innerWidth >= 1280 && sideBarInner && tocSect) {
      var relatedPosts = document.querySelector('.single-r-a'),
        sidebar = document.querySelector('.single-tmp__sidebar'),
        sidebarBottom = sidebar.getBoundingClientRect().bottom,
        windowYOffset = window.pageYOffset;

      // Calculate content scroll percentage
      if (content && secOfCallOut && secOfAlsoRead) {
        var contentHeight = content.offsetHeight;
        var contentTop = content.offsetTop;
        var scrolledFromContentTop = windowYOffset - contentTop;
        var scrollPercentage = (scrolledFromContentTop / contentHeight) * 100;

        // Calculate content scroll percentage
        if (scrollPercentage > 50) {
          // More than 50% scrolled - show Also Read, hide Call Out
          secOfAlsoRead.classList.remove('hide');
          secOfCallOut.classList.add('hide');
        } else {
          // Less than 50% scrolled - show Call Out, hide Also Read
          secOfCallOut.classList.remove('hide');
          secOfAlsoRead.classList.add('hide');
        }
      }

      if (windowYOffset <= content.offsetTop) {
        if (sideBarInner.classList.contains('toc-sticky') || sideBarInner.classList.contains('toc-bottom')) {
          sideBarInner.classList.remove('toc-sticky', 'toc-bottom');
        }
      } else if ((sidebarBottom - 131) <= 0) {
        if (sideBarInner.classList.contains('toc-sticky') || sideBarInner.classList.contains('toc-bottom')) {
          sideBarInner.classList.remove('toc-sticky', 'toc-bottom');
        }
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset  < (relatedPosts.offsetTop - tocSect.offsetHeight - 350)))) {
        if (!sideBarInner.classList.contains('toc-sticky')) {
          sideBarInner.classList.add('toc-sticky');
        }
        if (sideBarInner.classList.contains('toc-bottom')) {
          sideBarInner.classList.remove('toc-bottom');
        }
      } else {
        if (sideBarInner.classList.contains('toc-sticky')) {
          sideBarInner.classList.remove('toc-sticky');
        }
        if (!sideBarInner.classList.contains('toc-bottom')) {
          sideBarInner.classList.add('toc-bottom');
        }
      }
    } else {
      sideBarInner.classList.remove('toc-sticky', 'toc-bottom');
    }
  }

  init();
})();